import gsap from 'gsap'

import ee from '../ee'
import a11yPreferences from '../helpers/a11yPreferences'

function animateQuoteModule(element) {
  return gsap
    .timeline({
      scrollTrigger: {
        trigger: element.parentElement,
        start: '50px bottom',
        once: true,
      },
    })
    .from(element, { opacity: 0, ease: 'linear', duration: 1 })
    .from(
      element,
      { y: element.offsetHeight / 2, ease: 'sine.out', duration: 1 },
      '<'
    )
}

function init() {
  if (a11yPreferences.reducedMotion) {
    return
  }

  let quoteModules = Array.from(document.querySelectorAll('.quote-module'))
  quoteModules.forEach(animateQuoteModule)
}

ee.addListener('initComponents', init)
